'use client'

import { useRouter } from 'next/navigation'
import React, { useEffect } from 'react'

import { DEFAULT_CLIENT_ID } from './config'

export default function Home (): React.JSX.Element {
  const router = useRouter()

  useEffect(() => {
    // OAuth parameters must match mapquest.com integration
    const params = new URLSearchParams({
      client_id: DEFAULT_CLIENT_ID,
      redirect_uri: 'https://www.mapquest.com/api/auth/callback/mqidp',
      scope: 'openid email profile',
      response_type: 'code',
    })

    // Redirect to OAuth authorize endpoint
    const authorizeUrl = `/authorize?${params.toString()}`
    router.push(authorizeUrl)
  }, [router])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto" />
        <p className="mt-4 text-gray-600">Redirecting to MapQuest Identity...</p>
        <p className="mt-2 text-sm text-gray-500">
          You will be redirected to authenticate and then back to mapquest.com
        </p>
      </div>
    </div>
  )
}
